import {
  QUEUE_SYMBOLS,
  RANK_SYMBOLS,
  ROLE_SYMBOLS,
} from "@/game-lol/constants/constants.mjs";

export const DEFAULT_COMPARISON_RANK = RANK_SYMBOLS.gold;

export const COACHABLE_QUEUES = {
  [QUEUE_SYMBOLS.rankedSoloDuo]: true,
  [QUEUE_SYMBOLS.rankedFlex]: true,
  [QUEUE_SYMBOLS.normalDraft]: true,
  // temporary disable of Swiftplay due to RGAPI issues
  [QUEUE_SYMBOLS.swiftplay]: false,
  [QUEUE_SYMBOLS.clash]: true,
};

export const STAT_TRENDS = {
  neither: "neither",
  upward: "upward",
  downward: "downward",
};

export const MIN_TREND_STRENGTH = 0.05;
export const MAX_STATS_COUNT = 3;

// export const PLAT_INDEX = 4;
// export const DIAMOND_INDEX = 5;
export const CHALLENGER_INDEX = 8;
export const PEAK_APEX_RANK = CHALLENGER_INDEX;

// Based on the old Elixir data, no idea how they got this because its not an available timeline stat
export const MADEUP_VISION_SCORE_PER_MIN = {
  [RANK_SYMBOLS.iron]: 1.6,
  [RANK_SYMBOLS.bronze]: 1.9,
  [RANK_SYMBOLS.silver]: 2.0,
  [RANK_SYMBOLS.gold]: 2.1,
  [RANK_SYMBOLS.platinum]: 2.2,
  [RANK_SYMBOLS.emerald]: 2.3,
  [RANK_SYMBOLS.diamond]: 2.4,
  [RANK_SYMBOLS.master]: 2.6,
  [RANK_SYMBOLS.grandmaster]: 2.6,
  [RANK_SYMBOLS.challenger]: 2.6,
};

// Fill values (filling bars visually)
// ** Deprecating these to test a new method, maybe remove
// export const LOWER_MIN = 0.05;
// export const LOWER_MAX = 0.25;
// export const UPPER_MIN = 0.75;
// export const UPPER_MAX = 1;

// Score values (numerical representation)
export const SCORE_MIN = 0;
export const SCORE_MAX = 1;

export const STAT_COMPARE = {
  low: 0.8,
  okay: 0.99,
  good: 1.1,
};

export const COACHING_STATS = {
  kp: {
    key: "kp",
    keyData: "kp",
    min: 0,
    label: ["lol:coaching.killParticipation", "Kill Participation"],
    labelLane: [
      "lol:coaching.killParticipationLane",
      "Kill Participation - Lane Phase",
    ],
    labelMid: [
      "lol:coaching.killParticipationMid",
      "Kill Participation - Mid Game",
    ],
    description: [
      "lol:coaching.killParticipationDescription",
      "Team kills that you have contributed to (either by getting the kill or assisting).",
    ],
    descriptionLane: [
      "lol:coaching.killParticipationLaneDescription",
      "Team kills that you have contributed to (either by getting the kill or assisting) during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.killParticipationMidDescription",
      "Team kills that you have contributed to (either by getting the kill or assisting) during the Mid Game (~ 24 minutes).",
    ],
    format: {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  kda: {
    key: "kda",
    keyData: "kda",
    min: 0,
    label: ["common:stats.kda", "KDA"],
    labelLane: ["lol:coaching.kdaLane", "KDA - Lane Phase"],
    labelMid: ["lol:coaching.kdaMid", "KDA - Mid Game"],
    description: [
      "lol:coaching.kdaDescription",
      "Your ratio of deaths to every kill you participated in.",
    ],
    descriptionLane: [
      "lol:coaching.kdaDescriptionLane",
      "Your ratio of deaths to every kill you participated in during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.kdaDescriptionMid",
      "Your ratio of deaths to every kill you participated in during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
    eog: [
      ROLE_SYMBOLS.top,
      ROLE_SYMBOLS.jungle,
      ROLE_SYMBOLS.mid,
      ROLE_SYMBOLS.adc,
      ROLE_SYMBOLS.support,
    ],
  },
  ka: {
    key: "ka",
    keyData: "ka",
    min: 0,
    label: ["lol:coaching.killsAssists", "Kills + Assists"],
    labelLane: [
      "lol:coaching.killsAssistsLane",
      "Kills + Assists - Lane Phase",
    ],
    labelMid: ["lol:coaching.killAssistsMid", "Kills + Assists - Mid Game"],
    description: [
      "lol:coaching.killsAssistsDescription",
      "Total number of kills and assists you have accumulated.",
    ],
    descriptionLane: [
      "lol:coaching.killsAssistsLaneDescription",
      "Total number of kills and assists you have accumulated during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.killsAssistsMidDescription",
      "Total number of kills and assists you have accumulated during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  dmg: {
    key: "dmg",
    keyData: "damageDealt",
    min: 0,
    label: ["lol:coaching.damagePerMin", "Damage/min."],
    labelLane: ["lol:coaching.damagePerMinLane", "Damage/min. - Lane Phase"],
    labelMid: ["lol:coaching.damagePerMinMid", "Damage/min. - Mid Game"],
    description: [
      "lol:coaching.damagePerMinDescription",
      "The amount of damage you have dealt per minute.",
    ],
    descriptionLane: [
      "lol:coaching.damagePerMinLaneDescription",
      "The amount of damage you have dealt per minute during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.damagePerMinMdDescription",
      "The amount of damage you have dealt per minute during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    eog: [
      ROLE_SYMBOLS.top,
      ROLE_SYMBOLS.jungle,
      ROLE_SYMBOLS.mid,
      ROLE_SYMBOLS.adc,
      ROLE_SYMBOLS.support,
    ],
  },
  dmgEfficiency: {
    key: "dmg",
    keyData: "damageDealtPerGoldSpent",
    min: 0,
    label: ["lol:coaching.damagePerGoldSpent", "Damage/100 Gold Spent"],
    labelLane: [
      "lol:coaching.damagePerGoldSpentLane",
      "Damage/100 Gold Spent - Lane Phase",
    ],
    labelMid: [
      "lol:coaching.damagePerGoldSpentMid",
      "Damage/100 Gold Spent - Mid Game",
    ],
    description: [
      "lol:coaching.damagePerGoldSpentDescription",
      "The amount of damage you have dealt per 100 gold you have spent on items.",
    ],
    descriptionLane: [
      "lol:coaching.damagePerGoldSpentLaneDescription",
      "The amount of damage you have dealt per 100 gold you have spent on items (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.damagePerGoldSpentMidDescription",
      "The amount of damage you have dealt per 100 gold you have spent on items (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  dmgTaken: {
    key: "tankiness",
    keyData: "damageTakenPerDeath",
    min: 0,
    label: ["lol:coaching.tankiness", "Tankiness"],
    labelLane: ["lol:coaching.tankinessLane", "Tankiness - Lane Phase"],
    labelMid: ["lol:coaching.tankinessLaneMid", "Tankiness - Mid Game"],
    description: [
      "lol:coaching.damageTakenPerDeathDescription",
      "How much damage you were able to absorb per death (tankiness), more is better.",
    ],
    descriptionLane: [
      "lol:coaching.damageTakenPerDeathLaneDescription",
      "How much damage you were able to absorb per death (tankiness), more is better (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.damageTakenPerDeathMidDescription",
      "How much damage you were able to absorb per death (tankiness), more is better (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  cc: {
    key: "cc",
    keyData: "cc",
    min: 0,
    label: ["lol:coaching.ccPerMin", "Crowd Control/min."],
    labelLane: ["lol:coaching.ccPerMinLane", "Crowd Control/min. - Lane Phase"],
    labelMid: ["lol:coaching.ccPerMinMid", "Crowd Control/min. - Mid Game"],
    description: [
      "lol:coaching.ccPerMinDescription",
      "The amount of Crowd Control you have dealt per minute.",
    ],
    descriptionLane: [
      "lol:coaching.ccPerMinLaneDescription",
      "The amount of Crowd Control you have dealt per minute during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.ccPerMinMidDescription",
      "The amount of Crowd Control you have dealt per minute during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
  cs: {
    key: "cs",
    keyData: "cs",
    min: 0,
    label: ["lol:coaching.csPerMin", "CS/min."],
    labelLane: ["lol:coaching.csPerMinLane", "CS/min. - Lane Phase"],
    labelMid: ["lol:coaching.csPerMinMid", "CS/min. - Mid Game"],
    description: [
      "lol:coaching.csPerMinDescription",
      "The amount of minion you have killed per minute.",
    ],
    descriptionLane: [
      "lol:coaching.csPerMinLaneDescription",
      "The amount of minion you have killed per minute during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.csPerMinMidDescription",
      "The amount of minion you have killed per minute during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
  },
  xp: {
    key: "xp",
    keyData: "xp",
    min: 0,
    label: ["lol:coaching.xpPerMin", "XP/min."],
    labelLane: ["lol:coaching.xpPerMinLane", "XP/min. - Lane Phase"],
    labelMid: ["lol:coaching.xpPerMinMid", "XP/min. - Mid Game"],
    description: [
      "lol:coaching.xpPerMinDescription",
      "The amount of XP you have earned per minute.",
    ],
    descriptionLane: [
      "lol:coaching.xpPerMinLaneDescription",
      "The amount of XP you have earned per minute during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.xpPerMinMidDescription",
      "The amount of XP you have earned per minute during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    eog: [
      ROLE_SYMBOLS.top,
      ROLE_SYMBOLS.jungle,
      ROLE_SYMBOLS.mid,
      ROLE_SYMBOLS.adc,
      ROLE_SYMBOLS.support,
    ],
  },
  gold: {
    key: "gold",
    keyData: "gold",
    min: 0,
    label: ["lol:coaching.goldPerMin", "Gold/min."],
    labelLane: ["lol:coaching.goldPerMinLane", "Gold/min. - Lane Phase"],
    labelMid: ["lol:coaching.goldPerMinMid", "Gold/min. - Mid Game"],
    description: [
      "lol:coaching.goldPerMinDescription",
      "The amount of gold you have earned per minute.",
    ],
    descriptionLane: [
      "lol:coaching.goldPerMinLaneDescription",
      "The amount of gold you have earned per minute during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.goldPerMinMidDescription",
      "The amount of gold you have earned per minute during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    eog: [
      ROLE_SYMBOLS.top,
      ROLE_SYMBOLS.jungle,
      ROLE_SYMBOLS.mid,
      ROLE_SYMBOLS.adc,
      ROLE_SYMBOLS.support,
    ],
  },
  goldSpent: {
    key: "goldSpent",
    keyData: "goldSpent",
    min: 0,
    label: ["lol:coaching.goldSpent", "Total Gold Spent"],
    labelLane: ["lol:coaching.goldSpentLane", "Total Gold Spent - Lane Phase"],
    labelMid: ["lol:coaching.goldSpentMid", "Total Gold Spent - Mid Game"],
    description: [
      "lol:coaching.goldSpentDescription",
      "The amount of gold you have spent on items.",
    ],
    descriptionLane: [
      "lol:coaching.goldSpentLaneDescription",
      "The amount of gold you have spent on items during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.goldSpentMidDescription",
      "The amount of gold you have spent on items during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  controlWards: {
    key: "controlWards",
    keyData: "controlWards",
    min: 0,
    label: ["lol:coaching.controlWardsPlaced", "Control Wards Placed"],
    labelLane: [
      "lol:coaching.controlWardsPlacedLane",
      "Control Wards Placed - Lane Phase",
    ],
    labelMid: [
      "lol:coaching.controlWardsPlacedMid",
      "Control Wards Placed - Mid Game",
    ],
    description: [
      "lol:coaching.controlWardsPlacedDescription",
      "The number of Control Wards you have placed.",
    ],
    descriptionLane: [
      "lol:coaching.controlWardsPlacedLaneDescription",
      "The number of Control Wards you have placed during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.controlWardsPlacedMidDescription",
      "The number of Control Wards you have placed during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    eog: [
      ROLE_SYMBOLS.top,
      ROLE_SYMBOLS.jungle,
      ROLE_SYMBOLS.mid,
      ROLE_SYMBOLS.adc,
      ROLE_SYMBOLS.support,
    ],
  },
  stealthWards: {
    key: "stealthWards",
    keyData: "stealthWards",
    min: 0,
    label: ["lol:coaching.stealthWardsPlaced", "Stealth Wards Placed"],
    labelLane: [
      "lol:coaching.stealthWardsPlacedLane",
      "Stealth Wards Placed - Lane Phase",
    ],
    labelMid: [
      "lol:coaching.stealthWardsPlacedMid",
      "Stealth Wards Placed - Mid Game",
    ],
    description: [
      "lol:coaching.stealthWardsPlacedDescription",
      "The number of Stealth Wards you have placed.",
    ],
    descriptionLane: [
      "lol:coaching.stealthWardsPlacedLaneDescription",
      "The number of Stealth Wards you have placed during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.stealthWardsPlacedMidDescription",
      "The number of Stealth Wards you have placed during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    lane: [
      ROLE_SYMBOLS.top,
      ROLE_SYMBOLS.jungle,
      ROLE_SYMBOLS.mid,
      ROLE_SYMBOLS.adc,
    ],
    eog: [ROLE_SYMBOLS.support],
  },
  wardsKilled: {
    key: "wardsKilled",
    keyData: "wardsKilled",
    min: 0,
    label: ["lol:coaching.wardsKilled", "Wards Killed"],
    labelLane: ["lol:coaching.wardsKilledLane", "Wards Killed - Lane Phase"],
    labelMid: ["lol:coaching.wardsKilledMid", "Wards Killed - Mid Game"],
    description: [
      "lol:coaching.wardsKilledDescription",
      "The number of Wards you have killed.",
    ],
    descriptionLane: [
      "lol:coaching.wardsKilledLaneDescription",
      "The number of Wards you have killed during the lane phase (first 14 minutes).",
    ],
    descriptionMid: [
      "lol:coaching.wardsKilledMidDescription",
      "The number of Wards you have killed during the Mid Game (~ 24 minutes).",
    ],
    format: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
};

export const COACHING_CATEGORIES = {
  combat: [
    COACHING_STATS.dmg,
    COACHING_STATS.kda,
    // COACHING_STATS.ka,
    // COACHING_STATS.kp,
    // COACHING_STATS.dmgEfficiency,
    // COACHING_STATS.dmgTaken,
    // COACHING_STATS.cc,
  ],
  economy: [
    COACHING_STATS.gold,
    COACHING_STATS.xp,
    // COACHING_STATS.cs,
    // COACHING_STATS.goldSpent,
  ],
  vision: [
    COACHING_STATS.stealthWards,
    COACHING_STATS.controlWards,
    // COACHING_STATS.wardsKilled,
  ],
};

export const COACHING_INSIGHTS = {
  lanePhaseMultiDeath(laneGoldLost) {
    return {
      priority: 9,
      label: ["lol:coaching.tips.lowCs", "Low CS"],
      tags: [
        ["lol:laningPhase", "Laning Phase"],
        ["lol:coaching.tips.mulitpleDeaths", "Multiple Deaths"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.lostLaneCsNotPlayingSafe",
          "After falling behind in lane it's often better to play safe and wait for good opportunities to fight back.",
        ],
        [
          "lol:coaching.tips.freezeWaveAtTower",
          "Try to keep the wave near your turret to farm safely and make your enemy more gankable.",
        ],
        [
          "lol:coaching.tips.dontDieMultipleTimes",
          "Dying multiple times and snowballing the enemy makes it difficult for your teammates to carry.",
        ],
        [
          "lol:coaching.tips.laneGoldCSLost",
          "You lost ~{{laneGoldLost}} Gold during lane due to missed CS that you should have gotten.",
          { laneGoldLost },
        ],
      ],
    };
  },
  lanePhaseNoWardDeaths: {
    priority: 5,
    label: ["lol:coaching.tips.lowCs", "Low CS"],
    tags: [
      ["lol:laningPhase", "Laning Phase"],
      ["lol:coaching.tips.ganked", "Ganked"],
    ],
    lineItems: [
      [
        "lol:coaching.tips.wardFrequentlyWhenPushing",
        "Ward frequently, especially when pushing the lane.",
      ],
      [
        "lol:coaching.tips.whereEnemyJunglerCouldBe",
        "Frequently watch the map and think about where the enemy jungler *could* be.",
      ],
    ],
  },
  lanePhaseNoWardDeathsEarly: {
    priority: 6,
    label: ["lol:coaching.tips.lowCs", "Low CS"],
    tags: [
      ["lol:laningPhase", "Laning Phase"],
      ["lol:coaching.tips.ganked", "Ganked"],
    ],
    lineItems: [
      [
        "lol:coaching.tips.placeFirstWardBy",
        "Place your first ward by ~1:30 to spot early ganks.",
      ],
      [
        "lol:coaching.tips.wardFrequentlyWhenPushing",
        "Ward frequently, especially when pushing the lane.",
      ],
      [
        "lol:coaching.tips.carefulWhenPushing",
        "It's risky to push the lane without wards or knowledge of where the enemy jungler is.",
      ],
    ],
  },
  lanePhaseSoloDeaths(laneGoldLost) {
    return {
      priority: 6,
      label: ["lol:coaching.tips.lowCs", "Low CS"],
      tags: [
        ["lol:laningPhase", "Laning Phase"],
        ["lol:coaching.tips.soloDeaths", "Solo Deaths"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.laneGoldCSLost",
          "You lost ~{{laneGoldLost}} Gold during lane due to missed CS that you should have gotten.",
          { laneGoldLost },
        ],
        [
          "lol:coaching.tips.playSafeAndFarm",
          "Play safe and focus on last hitting minions.",
        ],
        [
          "lol:coaching.tips.freezeWaveAtTower",
          "Try to keep the wave near your turret to farm safely and make your enemy more gankable.",
        ],
      ],
    };
  },
  lanePhaseOverlyTrading: {
    priority: 5,
    label: ["lol:coaching.tips.lowCs", "Low CS"],
    tags: [
      ["lol:laningPhase", "Laning Phase"],
      ["lol:coaching.tips.overlyAggressive", "Overly Aggressive"],
    ],
    lineItems: [
      [
        "lol:coaching.tips.prioritizeLastHitting",
        "Prioritize last-hitting minions over dealing damage/fighting.",
      ],
      [
        "lol:coaching.tips.positionCarefullyToTrade",
        "Position carefully if you're losing lane to ensure you're still in XP range of minions.",
      ],
    ],
  },
  lanePhaseDamageLowGold: {
    priority: 5,
    label: ["lol:coaching.tips.lowDamage", "Low Damage"],
    tags: [["lol:laningPhase", "Laning Phase"]],
    lineItems: [
      [
        "lol:coaching.tips.prioritizeFarmingForItems",
        "You dealt considerably less damage than you should have because you were significantly behind economically. Focus on CSing so you are able to purchase impactful items in time.",
      ],
    ],
  },
  lanePhaseHarass: {
    priority: 4,
    label: ["lol:coaching.tips.lowDamage", "Low Damage"],
    tags: [["lol:laningPhase", "Laning Phase"]],
    lineItems: [
      [
        "lol:coaching.tips.lanePhaseHarass",
        "You dealt less damage during the laning phase than you should have because you weren't harassing the enemy. Use your abilities to apply early pressure.",
      ],
    ],
  },

  lanePhaseDeathsXP: {
    priority: 5,
    label: ["lol:coaching.tips.lowXp", "Low XP"],
    tags: [
      ["lol:laningPhase", "Laning Phase"],
      ["lol:coaching.tips.mulitpleDeaths", "Multiple Deaths"],
    ],
    lineItems: [
      [
        "lol:coaching.tips.lostLaneXpNotPlayingSafe",
        "You lost a lot of XP during lane phase due to deaths.",
      ],
      [
        "lol:coaching.tips.wardFrequentlyWhenPushing",
        "Ward frequently, especially when pushing the lane.",
      ],
    ],
  },
  lanePhaseSoloDeathsXP: {
    priority: 3,
    label: ["lol:coaching.tips.lowXp", "Low XP"],
    tags: [
      ["lol:laningPhase", "Laning Phase"],
      ["lol:coaching.tips.mulitpleDeaths", "Multiple Deaths"],
    ],
    lineItems: [
      [
        "lol:coaching.tips.prioritizeSurviving",
        "Prioritize staying alive over dealing damage/fighting.",
      ],
      [
        "lol:coaching.tips.positionCarefullyGetXP",
        "Try to stay in XP range when minions die as long as it is safe.",
      ],
    ],
  },
  lanePhaseXPRange: {
    priority: 4,
    label: ["lol:coaching.tips.lowXp", "Low XP"],
    tags: [
      ["lol:laningPhase", "Laning Phase"],
      ["lol:coaching.tips.xpRange", "XP Range"],
    ],
    lineItems: [
      [
        "lol:coaching.tips.positionCarefullyGetXP",
        "Try to stay in XP range when minions die as long as it is safe.",
      ],
    ],
  },
  lanePhaseRecallsXP(recallCount) {
    return {
      priority: 3,
      label: ["lol:coaching.tips.lowXp", "Low XP"],
      tags: [
        ["lol:laningPhase", "Laning Phase"],
        ["lol:coaching.tips.recalls", "Recalls"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.lostLaneXpRecalls",
          "You lost a lot of XP during lane phase likely due to recalling too many times ({{recallCount}}).",
          { recallCount },
        ],
        [
          "lol:coaching.tips.positionCarefullyToTrade",
          "Position carefully if you're losing lane to ensure you're still in XP range of minions.",
        ],
      ],
    };
  },
  midPhaseRecallsXP(recallCount) {
    return {
      priority: 3,
      label: ["lol:coaching.tips.lowXp", "Low XP"],
      tags: [
        ["lol:midGame", "Mid Game"],
        ["lol:coaching.tips.recalls", "Recalls"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.lostmidGameXpRecalls",
          "You lost a lot of XP during the Mid Game likely due to recalling too many times ({{recallCount}}).",
          { recallCount },
        ],
        [
          "lol:coaching.tips.roamingXpRangeOfMinions",
          "Ensure you're not overly roaming and that you're staying in XP range of minions for XP.",
        ],
      ],
    };
  },

  lanePhaseBadWards(placed, shouldHavePlaced) {
    return {
      priority: 4,
      label: ["lol:coaching.tips.poorVision", "Poor Vision"],
      tags: [
        ["lol:laningPhase", "Laning Phase"],
        ["lol:coaching.tips.stealthWards", "Stealth Wards"],
      ],
      lineItems: [
        // [
        //   "lol:coaching.tips.deathsGankPoorVision",
        //   "You died during lane phase to jungle ganks due to poor vision.",
        // ],
        [
          "lol:coaching.tips.wardsLaneShouldHavePlaced",
          "You placed {{placed}} / {{shouldHavePlaced}} stealth wards total during the lane phase.",
          { placed, shouldHavePlaced },
        ],
      ],
    };
  },
  midPhaseBadWards(placed, shouldHavePlaced) {
    return {
      priority: 3,
      label: ["lol:coaching.tips.poorVision", "Poor Vision"],
      tags: [
        ["lol:midGame", "Mid Game"],
        ["lol:coaching.tips.stealthWards", "Stealth Wards"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.wardsMidShouldHavePlaced",
          "You placed {{placed}} / {{shouldHavePlaced}} stealth wards total in the Mid Game.",
          { placed, shouldHavePlaced },
        ],
        [
          "lol:coaching.tips.useSupportWardsRegularly",
          "Make sure that you're placing all 3 Support Item Wards regularly (especially around objectives) and recalling to re-fill them.",
        ],
      ],
    };
  },
  latePhaseBadWards(placed, shouldHavePlaced) {
    return {
      priority: 3,
      label: ["lol:coaching.tips.poorVision", "Poor Vision"],
      tags: [
        ["lol:lateGame", "Late Game"],
        ["lol:coaching.tips.stealthWards", "Stealth Wards"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.wardsLateShouldHavePlaced",
          "You placed {{placed}} / {{shouldHavePlaced}} stealth wards total in the Late Game.",
          { placed, shouldHavePlaced },
        ],
        [
          "lol:coaching.tips.useSupportWardsRegularly",
          "Make sure that you're placing all 3 Support Item Wards regularly (especially around objectives) and recalling to re-fill them.",
        ],
      ],
    };
  },

  midPhaseBadCSDeaths(midGameDeaths, midGoldLost) {
    return {
      priority: 5,
      label: ["lol:coaching.tips.lowCs", "Low CS"],
      tags: [
        ["lol:midGame", "Mid Game"],
        ["lol:coaching.tips.deaths", "Deaths"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.midGoldCSFellOff",
          "You lost ~{{midGoldLost}} Gold due to your CS falling off in the Mid Game.",
          { midGoldLost },
        ],
        [
          "lol:coaching.tips.midDeathsCSLoss",
          "Your CS fell off in the Mid Game because you died several times ({{midGameDeaths}}). Try playing safer and focusing on farming.",
          { midGameDeaths },
        ],
      ],
    };
  },
  supportLowCS: {
    priority: 2,
    label: ["lol:coaching.tips.lowCs", "Low CS"],
    tags: [["common:eog", "End of Game"]],
    lineItems: [
      [
        "lol:coaching.tips.supportLowCS",
        "Make sure you're last hitting stray minions that are dying that no one else will get. The extra income allows you to purchase more Control Wards.",
      ],
    ],
  },

  midPhaseFightContributionDmg() {
    return {
      priority: 3,
      label: ["lol:coaching.tips.poorDamage", "Low Damage"],
      tags: [
        ["lol:midGame", "Mid Game"],
        ["lol:coaching.tips.fightParticipation", "Participation"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.midDamageLowFightContribution",
          "Your Mid Game damage was lower than it should have been because you weren't contributing to fights around the map.",
        ],
      ],
    };
  },
  midPhaseFightContributionGold() {
    return {
      priority: 2,
      label: ["lol:coaching.tips.poorGold", "Low Gold"],
      tags: [["lol:midGame", "Mid Game"]],
      lineItems: [
        [
          "lol:coaching.tips.midGoldLowFightContribution",
          "Your Mid Game gold was lower than it should have been because you over-prioritzed CSing instead of participating in Mid-game fights.",
        ],
      ],
    };
  },
  midPhaseDamageLowDeaths(deathcount) {
    return {
      priority: 3,
      label: ["lol:coaching.tips.poorDamage", "Low Damage"],
      tags: [
        ["lol:midGame", "Mid Game"],
        ["lol:coaching.tips.deaths", "Deaths"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.midDamageLowDamageHighDeaths",
          "Your Mid Game damage was lower than it should have been because you died a lot in the Mid Game ({{ deathcount }} deaths).",
          { deathcount },
        ],
      ],
    };
  },
  midPhaseDamageLowKDA(deathcount) {
    return {
      priority: 2,
      label: ["lol:coaching.tips.poorDamage", "Low Damage"],
      tags: [
        ["lol:midGame", "Mid Game"],
        ["lol:coaching.tips.deaths", "Deaths"],
      ],
      lineItems: [
        [
          "lol:coaching.tips.midDamageLowKDAHighDeaths",
          "Your Mid Game KDA was lower than it should have been because you died a lot in the Mid Game ({{ deathcount }} deaths).",
          { deathcount },
        ],
      ],
    };
  },

  noControlWardPlaced(shouldHavePlaced) {
    return {
      priority: 5,
      label: ["lol:coaching.tips.poorVision", "Poor Vision"],
      tags: [["lol:coaching.tips.controlWards", "Control Wards"]],
      lineItems: [
        [
          "lol:coaching.tips.noControlWardsPlace",
          "You placed 0 / {{shouldHavePlaced}} control wards. Make sure you're buying control wards to provide and deny vision around Objectives and choke points.",
          { shouldHavePlaced },
        ],
      ],
    };
  },
  killWards: {
    priority: 4,
    label: ["lol:coaching.tips.poorVision", "Poor Vision"],
    tags: [["lol:coaching.tips.visionControl", "Vision Control"]],
    lineItems: [
      [
        "lol:coaching.tips.noWardKills",
        "You didn't kill any wards throughout the entire game. Use Control Wards in locations that you *KNOW* are warded to actively deny vision.",
      ],
    ],
  },
};
